<template>
  <x-float-ad
    v-if="!prevPageIsHome"
    :image="require('./images/更多好物.png')"
    :track="{
      name: '更多好物',
      id: 'bbc3501f-300c-454a-b34d-e0d6c9ca4e3b',
    }"
    @click="handleClick"
  />
</template>

<script>
  import Vue from 'vue'
  import { navigateBackOrTo, prevPageIs } from '@/router'

  export default Vue.extend({
    data: () => ({
      prevPageIsHome: prevPageIs('HomeIndex'),
    }),

    methods: {
      handleClick() {
        navigateBackOrTo('HomeIndex')
      },
    },
  })
</script>
